<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/forum">Forum</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Lista</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <!-- End .breadcrumb-nav -->
    <LoadedComponent :loading="loading" />
    <div class="container" v-if="!loading">
      <!-- Componente alert -->
      <!-- <AlertComponent :message="successMessage" :alert-type="'success'" /> -->
      <div class="alert alert-success mb-2" v-if="successMessage">
        <h5 style="color: white; text-align: center; font-family: sans-serif">
          {{ successMessage }}
        </h5>
      </div>
      <AlertComponent :message="errormessage" :alert-type="'danger'" />
      <div class="row">
        <!-- Controlla che lo possa utilizzare-->
        <div
          class="col-md-3 pt-0 pt-md-2 pl-0 pl-md-5 mb-0 mb-md-4 text-center"
        >
          <!-- pt-0 pt-md-2 pl-0 pl-md-5  mb-0 mb-md-4 -->
          <button
            type="button"
            class="btn btn-primary custom-primary"
            data-toggle="modal"
            data-target="#forum-create-modal"
          >
            Crea una nuova discussione
          </button>
        </div>

        <div
          class="col-md-9 pt-0 pt-md-2 pl-0 pl-md-5 mb-0 mb-md-4 m-3 m-md-0 text-center"
        >
          <div class="widget widget-search">
            <form method="post" id="cipriani-general-search">
              <label for="ws" class="sr-only">Cerca fra i casi</label>
              <input
                type="search"
                class="form-control"
                name="q"
                id="ws"
                v-model="searchText"
                placeholder="Cerca il titolo fra le discussioni"
                @input="performSearchForum"
                required
              />
              <button type="button" class="btn">
                <i class="icon-search"></i><span class="sr-only">Cerca</span>
              </button>
            </form>
          </div>
          <!-- End .widget -->
        </div>
      </div>
      <!-- Blog Post -->
      <div class="col-sm-12">
        <div>
          <div class="row reload-forum-page" v-if="forums.length > 0">
            <div class="col-lg-6" v-for="forum in forums" :key="forum.id">
              <div class="product product-7 text-center">
                <div class="entry-body">
                  <div class="entry-meta">
                    <h2 class="entry-title">
                      <router-link :to="'/forum/' + forum.slug">{{
                        forum.name
                      }}</router-link>
                    </h2>
                    <!-- End .entry-title -->
                  </div>
                  <!-- End .entry-meta -->

                  <div class="entry-cats">
                    <a href="#"><!-- nome_categoria_medica --></a>
                  </div>
                  <!-- End .entry-cats -->

                  <div class="entry-content">
                    <p>
                      {{ forum.short_description }}
                    </p>
                    <router-link
                      :to="'/forum/' + forum.slug"
                      class="read-more"
                      v-if="forum.show_forum"
                      >Entra nella discussione</router-link
                    >
                  </div>
                  <!-- End .entry-content -->
                  <div class="entry-meta pt-4">
                    <span class="entry-author">
                      Pubblicato da <a href="#">{{ forum.full_name }}</a>
                    </span>
                    <span class="meta-separator">|</span>
                    <a href="data-">{{ forum.publish_date }}</a>
                    <span class="meta-separator">|</span>
                    <a>{{ forum.hospital }}</a>
                  </div>
                  <!-- End .entry-meta -->
                </div>
                <!-- End .entry-body -->
              </div>
              <!-- End .row -->
            </div>
            <!-- End .col-lg-9 -->
            <hr />
          </div>

          <div class="row reload-forum-page" v-else>
            <p>Nessun risltato</p>
          </div>
        </div>
        <!-- End .row -->
      </div>
    </div>
    <div
      class="modal fade"
      id="forum-create-modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>

            <div class="form-box">
              <div class="form-tab">
                <ul class="nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="signin-tab"
                      data-toggle="tab"
                      href="#signin"
                      role="tab"
                      aria-controls="signin"
                      aria-selected="true"
                      >Nuova discussione</a
                    >
                  </li>
                </ul>
                <div class="tab-content" id="tab-content-5">
                  <div
                    class="tab-pane fade show active"
                    id="signin"
                    role="tabpanel"
                    aria-labelledby="signin-tab"
                  >
                    <form @submit.prevent="sendNewForum">
                      <div class="form-group">
                        <label for="title-forum">Titolo discussione</label>
                        <input
                          type="text"
                          class="form-control"
                          id="title-forum"
                          name="nome"
                          v-model="form.name"
                          placeholder="Scrivi il titolo della discussione"
                        />
                      </div>
                      <!-- End .form-group -->
                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>

                      <div class="form-group">
                        <label for="description-forum">Messaggio</label>
                        <textarea
                          class="form-control"
                          id="description-forum"
                          name="descrizione"
                          v-model="form.description"
                          placeholder="Descrivi la discussione "
                        ></textarea>
                      </div>
                      <!-- End .form-group -->
                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>

                      <div class="form-footer">
                        <button
                          type="submit"
                          class="btn btn-outline-primary-2 btn-order btn-block"
                        >
                          <span class="btn-text">Invia</span>
                          <span class="btn-hover-text"
                            >Pubblica la discussione</span
                          >
                        </button>
                      </div>
                      <!-- End .form-footer -->
                    </form>
                  </div>
                  <!-- .End .tab-pane -->
                </div>
                <!-- End .tab-content -->
              </div>
              <!-- End .form-tab -->
            </div>
            <!-- End .form-box -->
          </div>
          <!-- End .modal-body -->
        </div>
        <!-- End .modal-content -->
      </div>
      <!-- End .modal-dialog -->
    </div>

    <!-- End .modal -->
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "ForumPage",
  props: {},
  components: { LoadedComponent },
  data() {
    return {
      successMessage: "",
      errormessage: "",
      forums: [],
      searchText: "",
      allForum: [],
      errors: [],
      loading: true,
      form: {
        name: "",
        description: "",
      },
    };
  },
  mounted() {
    this.successMessage = localStorage.getItem("messageSuccessForum");

    localStorage.removeItem("messageSuccessForum");
    httpauth
      .get("/forum")
      .then((response) => {
        var data = response.data;
        this.forums = data.data;
        this.allForum = data.data;
        this.loading = false;

        // Gestisci l'array di oggetti come desiderato
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        ) {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      });
  },
  created() {},
  methods: {
    performSearchForum() {
      if (!this.searchText) {
        this.forums = this.allForum;
        return;
      }
      var searchTerm = this.searchText.toLowerCase();
      this.forums = this.allForum.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm) ||
          item.description.toLowerCase().includes(searchTerm)
      );
    },
    async sendNewForum() {
      await httpauth
        .post("/forum/store", this.form)
        .then((response) => {
          this.successMessage = response.data.message;
          $("#forum-create-modal").modal("hide");
          this.forums = response.data.data;
          this.form.name = "";
          this.form.description = "";
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>